<template>

    <form action="#" method="POST" @submit.prevent="abreModalConfirmacao" v-if="analise.id != null">

        <div class="row">

            <vc-confirma-resultado
                    :callback-sucesso="enviarResultado"
                    :analise="analise">
            </vc-confirma-resultado>

            <div class="col-xs-12"
                 v-if="typeof analise.proprietarios != 'undefined' && analise.proprietarios.length > 0">
                <table class="table table-striped">
                    <tbody>
                    <tr>
                        <td colspan="2"><b>Proprietários</b></td>
                    </tr>
                    </tbody>
                    <tbody v-for="(proprietario, index) in analise.proprietarios">
                    <tr>
                        <td width="50%" class="text-capitalize" v-if="proprietario.tipo == 1">{{proprietario.nome}}</td>
                        <td width="50%" class="text-capitalize" v-else="">{{proprietario.razao_social}}<br/>{{proprietario.fantasia}}
                        </td>
                        <td width="50%" v-if="proprietario.tipo == 1">{{proprietario.cpf}}</td>
                        <td width="50%" v-if="proprietario.tipo == 2">{{proprietario.cnpj}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-xs-12"
                 v-if="typeof analise.arrendatarios != 'undefined' && analise.arrendatarios.length > 0">
                <table class="table table-striped">
                    <tbody>
                    <tr>
                        <td colspan="2"><b>Arrendatários</b></td>
                    </tr>
                    </tbody>
                    <tbody v-for="(arrendatario, index) in analise.arrendatarios">
                    <tr>
                        <td width="50%" class="text-capitalize" v-if="arrendatario.tipo == 1">{{arrendatario.nome}}</td>
                        <td width="50%" class="text-capitalize" v-else="">{{arrendatario.razao_social}}<br/>{{arrendatario.fantasia}}
                        </td>
                        <td width="50%" v-if="arrendatario.tipo == 1">{{arrendatario.cpf}}</td>
                        <td width="50%" v-if="arrendatario.tipo == 2">{{arrendatario.cnpj}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-xs-12" v-if="typeof analise.remetente != 'undefined' && analise.remetente.id > 0">
                <table class="table table-striped">
                    <tbody>
                    <tr>
                        <td colspan="2"><b>Remetente</b></td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr>
                        <td width="50%" class="text-capitalize" v-if="analise.remetente.tipo == 1">
                            {{analise.remetente.nome}}
                        </td>
                        <td width="50%" class="text-capitalize" v-else="">{{analise.remetente.razao_social}}<br/>{{analise.remetente.fantasia}}
                        </td>
                        <td width="50%" v-if="analise.remetente.tipo == 1">{{analise.remetente.cpf}}</td>
                        <td width="50%" v-if="analise.remetente.tipo == 2">{{analise.remetente.cnpj}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-xs-12">
                <table class="table table-bordered table-striped">
                    <tbody>
                    <tr>
                        <td width="33%"><b>Registro</b></td>
                        <td width="33%"><b>Data de registro</b></td>
                        <td width="33%"><b>Município - UF</b></td>
                    </tr>

                    <tr>
                        <td>{{ analise.registro }} / {{ analise.ano_registro }}</td>
                        <td>{{ analise.data_registro | formataData }}</td>
                        <td>{{ analise.cidade.nome }} - {{ analise.cidade.estado.uf }}</td>
                    </tr>


                    <tr v-if="analise.tipo === 'SEMENTE'">
                        <td><b>Amostra</b></td>
                        <td><b>Lote</b></td>
                        <td><b>Safra</b></td>
                    </tr>
                    <tr v-if="analise.tipo === 'SEMENTE'">
                        <td>{{ analise.semente.amostra }}</td>
                        <td>{{ analise.semente.lote }}</td>
                        <td>{{ analise.semente.safra }}</td>
                    </tr>


                    <tr v-if="analise.tipo === 'TECIDO'">
                        <td><b>Cultura</b></td>
                        <td colspan="2"><b>Referência</b></td>
                    </tr>
                    <tr v-if="analise.tipo === 'TECIDO'">
                        <td>{{ analise.cultura.nome }}</td>
                        <td colspan="3">{{ analise.tecido.referencia }}</td>
                    </tr>


                    <tr v-if="analise.tipo === 'FERTILIZANTE'">
                        <td><b>Nitrogênio</b></td>
                        <td><b>Fósforo</b></td>
                        <td><b>Potássio</b></td>
                    </tr>
                    <tr v-if="analise.tipo === 'FERTILIZANTE'">
                        <td>{{ analise.fertilizante.nitrogenio }} %</td>
                        <td>{{ analise.fertilizante.fosforo }} %</td>
                        <td>{{ analise.fertilizante.potassio }} %</td>
                    </tr>

                    <tr v-if="analise.tipo === 'SOLO'">
                        <td>Localidade</td>
                        <td>{{ analise.localidade }}</td>
                        <td></td>
                    </tr>

                    </tbody>
                </table>

                <div v-if="analise.tipo == 'SOLO'">
                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox" v-model="analise.solo_quimica"
                                                                        disabled><span></span></label>&nbsp;Química
                        </div>
                    </div>
                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox" v-model="analise.solo_fisica"
                                                                        disabled><span></span></label>&nbsp;Física
                        </div>
                    </div>
                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="analise.solo_extrato_saturacao"
                                                                        disabled><span></span></label>&nbsp;Extrato
                            saturação
                        </div>
                    </div>

                     <div class="col-xs-6 col-md-4" v-if="analise.id_coleta_app != undefined && analise.id_coleta_app != null">
                        <div class="form-group">
                            <label class="switch switch-success">
                                <input type="checkbox" checked disabled><span></span></label>&nbsp; Agricultura de precisão
                        </div>
                    </div>

                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                v-model="analise.analisa_ph_calc2"
                                disabled><span></span></label>&nbsp; Analise de PH (calc2)
                        </div>
                    </div>

                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                v-model="analise.analisa_fosforo_resina"
                                disabled><span></span></label>&nbsp; Analise de fosforo (resina)
                        </div>
                    </div>

                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                v-model="analise.analisa_ferro"
                                disabled><span></span></label>&nbsp; Analise de ferro
                        </div>
                    </div>

                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                v-model="analise.analisa_condutividade"
                                disabled><span></span></label>&nbsp; Analise de Condutividade
                        </div>
                    </div>

                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                v-model="analise.analisa_nitrogenio_azoto"
                                disabled><span></span></label>&nbsp; Analise de Nitrogenio (azoto)
                        </div>
                    </div>

                    <div class="col-xs-6 col-md-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                v-model="analise.analisa_silicio"
                                disabled><span></span></label>&nbsp; Analise de Silicio
                        </div>
                    </div>

                    <!--<div class="col-xs-6 col-md-3">-->
                    <!--<div class="form-group">-->
                    <!--<label class="switch switch-success"><input type="checkbox" v-model="analise.solo_metais_pesados" disabled><span></span></label>&nbsp;Metais pesados-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </div>

            <div v-if="analise.pedido_id == null && analise.forma_pagamento == 'BOLETO'">
                <div class="col-xs-12">
                    <h3 class="title">Boleto</h3>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Boleto para</label>
                        <v-select
                                v-model="analise.boleto"
                                v-validate="{required: true}"
                                :options="[{value: 'REMETENTE',label: 'Remetente'}, {value: 'PROPRIETARIO',label: 'Produtor / Proprietário'}, {value: 'ARRENDATARIO',label: 'Proprietário / Cedente'}]"
                                data-vv-name="enviar boleto"
                        ></v-select>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group" :class="{'has-error': errors.has('vencimento')}">
                        <label>Vencimento</label>
                        <Datepicker :value="analise.data_vencimento" v-model="analise.data_vencimento"
                                    v-validate="'required'" data-vv-name="vencimento"/>
                    </div>
                </div>
            </div>

            <div v-if="analise.tipo === 'FERTILIZANTE'">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Referência</label>
                        <input type="text" onClick="this.select();" v-model="analise.fertilizante.referencia"
                               class="form-control" data-vv-name="refêrencia"/>
                    </div>
                </div>
            </div>

            <div class="col-xs-12">
                <h3 class="title">Resultado</h3>
            </div>

            <div v-if="analise.tipo === 'SEMENTE'">
                <div class="col-xs-12 col-md-4" v-if="analise.semente_germinacao">
                    <div class="form-group">
                        <label>Germinação (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.semente.germinacao"
                               v-validate="{required: true}" class="form-control" data-vv-name="germinação"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4" v-if="analise.semente_vigor">
                    <div class="form-group">
                        <label>Vigor (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.semente.vigor"
                               v-validate="{required: true}" class="form-control" data-vv-name="vigor"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Pureza (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.semente.pureza"
                               v-validate="{required: true}" class="form-control" data-vv-name="pureza"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Peso de mil sementes (gramas) </label>
                        <input type="text" onClick="this.select();" v-model="analise.semente.peso_mil_sementes"
                               v-validate="{required: true}" class="form-control" data-vv-name="peso"/>
                    </div>
                </div>
            </div>

            <div v-if="analise.tipo === 'TECIDO'">
                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Nitrogênio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.nitrogenio" class="form-control"
                                                     @input="calculaAvaliacao('nitrogenio', analise.tecido.nitrogenio)"
                                                     v-validate="{required: true}" data-vv-name="nitrogênio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.nitrogenio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Fósforo (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.fosforo" class="form-control"
                                                     @input="calculaAvaliacao('fosforo', analise.tecido.fosforo)"
                                                     v-validate="{required: true}" data-vv-name="fósforo"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.fosforo_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Potássio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.potassio" class="form-control"
                                                     @input="calculaAvaliacao('potassio', analise.tecido.potassio)"
                                                     v-validate="{required: true}" data-vv-name="potássio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.potassio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Cálcio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.calcio" class="form-control"
                                                     @input="calculaAvaliacao('calcio', analise.tecido.calcio)"
                                                     v-validate="{required: true}" data-vv-name="cálcio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.calcio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Magnésio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.magnesio" class="form-control"
                                                     @input="calculaAvaliacao('magnesio', analise.tecido.magnesio)"
                                                     v-validate="{required: true}" data-vv-name="magnésio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.magnesio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Enxofre (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.enxofre" class="form-control"
                                                     @input="calculaAvaliacao('enxofre', analise.tecido.enxofre)"
                                                     v-validate="{required: true}" data-vv-name="enxofre"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.enxofre_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Zinco (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.tecido.zinco"
                                                     class="form-control"
                                                     @input="calculaAvaliacao('zinco', analise.tecido.zinco)"
                                                     v-validate="{required: true}" data-vv-name="zinco"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.zinco_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Manganês (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                     v-model="analise.tecido.manganes" class="form-control"
                                                     @input="calculaAvaliacao('manganes', analise.tecido.manganes)"
                                                     v-validate="{required: true}" data-vv-name="manganês"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.manganes_avaliacao" readonly></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Boro (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.tecido.boro"
                                                     class="form-control"
                                                     @input="calculaAvaliacao('boro', analise.tecido.boro)"
                                                     v-validate="{required: true}" data-vv-name="boro"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.boro_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Sódio (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.tecido.sodio"
                                                     class="form-control"
                                                     @input="calculaAvaliacao('sodio', analise.tecido.sodio)"
                                                     v-validate="{required: true}" data-vv-name="sódio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.sodio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Ferro (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.tecido.ferro"
                                                     class="form-control"
                                                     @input="calculaAvaliacao('ferro', analise.tecido.ferro)"
                                                     v-validate="{required: true}" data-vv-name="ferro"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                     v-model="analise.tecido.ferro_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Cobre (mg/kg)</div>
                        <div class="col-xs-3">
                            <input type="text" v-model="analise.tecido.cobre" class="form-control"/>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12">
                    <div class="text-center">
                        <h4>Elementos adicionais</h4>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Primeiro elemento</div>
                        <div class="col-xs-4">
                            <input type="text" v-model="analise.tecido.desc_elemento_adicional_um" class="form-control" placeholder="Descrição"/>
                        </div>
                        <div class="col-xs-3">
                            <input type="text" v-model="analise.tecido.vlr_elemento_adicional_um" class="form-control" placeholder="Valor (mg/KG)"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Segundo elemento</div>
                        <div class="col-xs-4">
                            <input type="text" v-model="analise.tecido.desc_elemento_adicional_dois" class="form-control" placeholder="Descrição"/>
                        </div>
                        <div class="col-xs-3">
                            <input type="text" v-model="analise.tecido.vlr_elemento_adicional_dois" class="form-control" placeholder="Valor (mg/KG)"/>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="analise.tipo === 'FERTILIZANTE'">
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Nitrogênio (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.fertilizante.nitrogenio_resultado"
                               v-validate="{required: true}" class="form-control" data-vv-name="nitrogênio"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Fósforo (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.fertilizante.fosforo_resultado"
                               v-validate="{required: true}" class="form-control" data-vv-name="fósforo"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Potássio (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.fertilizante.potassio_resultado"
                               v-validate="{required: true}" class="form-control" data-vv-name="potássio"/>
                    </div>
                </div>
            </div>

            <div class="row" v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1" style="margin-left: 3px; margin-right: 0px;">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>pH</label>
                        <the-mask mask="#,#" :masked="true" type="text" onClick="this.select();"
                                v-model="analise.solo.ph" @input="calculaSMP"
                                v-validate="{required: true}" class="form-control" data-vv-name="pH"></the-mask>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Matéria orgânica (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.materia_organica"
                            v-validate="{required: true}" class="form-control" data-vv-name="matéria orgânica"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Fósforo (P) (mg/L)</label>
                    <input type="text" onClick="this.select();" v-model="analise.solo.fosforo"
                            v-validate="{required: true}" class="form-control" data-vv-name="fósforo"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Potássio (K) (mg/L) </label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.potassio"
                            v-validate="{required: true}" class="form-control" data-vv-name="potássio"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Fósforo Rem (P) (mg/L)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.fosforo_rem"
                            v-validate="{required: true}" class="form-control" data-vv-name="fósforo rem"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Cálcio (Ca ²+) (cmol(c)/L)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.calcio"
                            v-validate="{required: true}" class="form-control" data-vv-name="cálcio"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Magnésio (mg ²+) (cmol(c)/L)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.magnesio"
                            v-validate="{required: true}" class="form-control" data-vv-name="magnésio"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Alumínio (Al ³+) (cmol(c)/L)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.aluminio"
                            v-validate="{required: true}" class="form-control" data-vv-name="alumínio"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Cobre (Cu)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.cobre"
                            class="form-control" data-vv-name="cobre"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Zinco (Zn)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.zinco"
                                class="form-control" data-vv-name="zinco"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Manganês (Mn)</label>
                    <input type="text" onClick="this.select();" v-model="analise.solo.manganes"
                            class="form-control" data-vv-name="manganes"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Sódio (Na) (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.sodio"
                            v-validate="{required: true}" class="form-control" data-vv-name="sódio"/>
                    </div>
                </div>
            </div>

            <div class="row" v-if="analise.tipo == 'SOLO' && (analise.solo_quimica == 1 || analise.solo_fisica == 1)" style="margin-left: 3px; margin-right: 0px;">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group" :class="{'has-error': errors.has('argila')}">
                        <label>Argila</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.argila" @input="calculaSilte"
                               v-validate="'required'" class="form-control" data-vv-name="argila"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.solo_fisica == 1">
                    <div class="form-group">
                        <label>Areia</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.areia" @input="calculaSilte"
                            v-validate="{required: true}" class="form-control" data-vv-name="areia"/>
                    </div>
                </div>
            </div>

            <div class="row" v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1" style="margin-left: 3px; margin-right: 0px;">
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <button :disabled="liberaForm" type="submit" class="btn btn-success">Salvar</button> &nbsp;
                        <router-link :to="{name: 'analises', params: {'GUIA': 'PENDENTES'}}" class="btn btn-danger">
                            Cancelar
                        </router-link>
                    </div>
                </div>
            </div>

            <div v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Boro (B)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.boro"
                                class="form-control" data-vv-name="boro"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Enxofre (S)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.enxofre"
                                class="form-control" data-vv-name="enxofre"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_ph_calc2">
                    <div class="form-group">
                        <label>Ph CaCl2</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.ph_cacl2"
                                class="form-control" data-vv-name="ph_cacl2"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_fosforo_resina">
                    <div class="form-group">
                        <label>Fósforo em resina</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.fosforo_resina"
                                class="form-control" data-vv-name="fosforo_resina"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_ferro">
                    <div class="form-group">
                        <label>Ferro (Fe)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.ferro"
                                class="form-control" data-vv-name="ferro"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_silicio">
                    <div class="form-group">
                        <label>Silício (Si)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.silicio"
                                class="form-control" data-vv-name="silicio"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_condutividade">
                    <div class="form-group">
                        <label>Condutividade (μS/cm)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.condutividade"
                            class="form-control" data-vv-name="condutividade"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_nitrogenio_azoto">
                    <div class="form-group">
                        <label>Nitrogênio Azoto</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.nitrogenio_azoto"
                            class="form-control" data-vv-name="Nitrogenio_azoto"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>SMP</label>
                        <money v-model="analise.solo.smp" class="form-control" readonly></money>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Hidrogênio + Al (cmol(c)/L)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.hidrogenio_al"
                            class="form-control" data-vv-name="hidrogenio_al"/>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4" v-if="analise.tipo === 'SOLO' && analise.solo_fisica == 1">
                <div class="form-group">
                    <label>Silte</label>
                    <input v-model="analise.solo.silte" class="form-control" readonly/>
                </div>
            </div>

            <div v-if="analise.tipo === 'SOLO' && analise.solo_extrato_saturacao == 1">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Condutividade (µs.cm-1)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.condutividade_saturacao"
                               v-validate="{required: true}" class="form-control" data-vv-name="condutividade"/>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Alumínio (Al) (mg/L)</label>
                        <input type="text" onClick="this.select();" v-model="analise.solo.aluminio_saturacao"
                               v-validate="{required: true}" class="form-control" data-vv-name="alumínio"/>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="analise.tipo != 'SOLO' || analise.solo_quimica != 1">
            <div class="col-xs-12 col-md-4">
                <div class="form-group">
                    <button :disabled="liberaForm" type="submit" class="btn btn-success">Salvar</button> &nbsp;
                    <router-link :to="{name: 'analises', params: {'GUIA': 'PENDENTES'}}" class="btn btn-danger">
                        Cancelar
                    </router-link>
                </div>
            </div>
        </div>
    </form>

</template>

<script>

    import VcConfirmaResultado from "./ConfirmaResultado";
    import Datepicker from "@/components/Form/Datepicker";
    import armazenaPedido from './services/armazenar_pedido';

    export default {
        name: 'digitar-resultados',
        data() {
            return {
                analise: {},
                mostraModalConfirmacao: false
            }
        },
        computed: {
            liberaForm() {
                let desabilita = true

                if (this.analise.tipo === 'SEMENTE') {
                    return false
                }

                if (this.analise.tipo === 'TECIDO') {
                    desabilita = this.analise.tecido.nitrogenio == 0 || this.analise.tecido.nitrogenio_avaliacao == 0 || this.analise.tecido.fosforo == 0 || this.analise.tecido.fosforo_avaliacao == 0 ||
                        this.analise.tecido.potassio == 0 || this.analise.tecido.potassio_avaliacao == 0 || this.analise.tecido.calcio == 0 || this.analise.tecido.calcio_avaliacao == 0 || this.analise.tecido.magnesio == 0 ||
                        this.analise.tecido.magnesio_avaliacao == 0 || this.analise.tecido.enxofre == 0 || this.analise.tecido.enxofre_avaliacao == 0 || this.analise.tecido.zinco == 0 || this.analise.tecido.zinco_avaliacao == 0 ||
                        this.analise.tecido.manganes == 0 || this.analise.tecido.manganes_avaliacao == 0 || this.analise.tecido.boro == 0 || this.analise.tecido.boro_avaliacao == 0 || this.analise.tecido.sodio == 0 ||
                        this.analise.tecido.sodio_avaliacao == 0 || this.analise.tecido.ferro == 0 || this.analise.tecido.ferro_avaliacao == 0;
                    if (desabilita) {
                        return desabilita
                    }
                }

                if (this.analise.tipo === 'FERTILIZANTE') {
                    desabilita = this.analise.fertilizante.nitrogenio_resultado == 0 || this.analise.fertilizante.fosforo_resultado == 0 || this.analise.fertilizante.potassio_resultado == 0;
                    if (desabilita) {
                        return desabilita
                    }
                }

                if (this.analise.tipo == 'SOLO' && this.analise.solo_quimica == 1) {
                    desabilita = this.analise.solo.ph == 0 || this.analise.solo.smp == 0 || this.analise.solo.materia_organica == 0 || this.analise.solo.fosforo == 0 || this.analise.solo.potassio == 0 || this.analise.solo.fosforo_rem == 0 ||
                        this.analise.solo.calcio == 0 || this.analise.solo.magnesio == 0 || this.analise.solo.hidrogenio_al == 0 || this.analise.solo.sodio == 0;
                    if (desabilita) {
                        return desabilita
                    }
                }

                if (this.analise.tipo === 'SOLO' && (this.analise.solo_fisica == 1 || this.analise.solo_quimica == 1)) {
                    desabilita = this.analise.solo.argila == 0;
                    if (desabilita) {
                        return desabilita
                    }
                }

                if (this.analise.tipo === 'SOLO' && this.analise.solo_fisica == 1) {
                    desabilita = this.analise.solo.areia == 0 || this.analise.solo.silte == 0;
                    if (desabilita) {
                        return desabilita
                    }
                }

                if (this.analise.tipo === 'SOLO' && this.analise.solo_extrato_saturacao == 1) {
                    desabilita = this.analise.solo.condutividade_saturacao == 0 || this.analise.solo.aluminio_saturacao == 0;
                    if (desabilita) {
                        return desabilita
                    }
                }

                return desabilita
            }
        },

        components: {
            VcConfirmaResultado, Datepicker,
        },
        methods: {
            abreModalConfirmacao() {
                if (this.analise.forma_pagamento === 'BOLETO' && this.analise.arrendatarios.length == 0 && this.analise.boleto.value === 'ARRENDATARIO') {
                    window.swal("Atenção", "Não é possivel gerar Boleto / NFS-e nesta analise, a mesma está sem arrendatário informado.", "warning");
                    return false;
                }
                return $("#confirma-resultado").modal('show')
            },
            calculaAvaliacao(campo) {

                let cultura = this.analise.cultura
                let valor = this.analise.tecido[campo];

                // default
                this.$set(this.analise.tecido, (campo + '_avaliacao'), 'Deficiente')

                if (parseFloat(valor.replace(',', '.')) <= parseFloat(cultura[campo + "_d_max"].replace(',', '.'))) {
                    this.$set(this.analise.tecido, (campo + '_avaliacao'), 'Deficiente')
                }
                if (parseFloat(valor.replace(',', '.')) >= parseFloat(cultura[campo + "_n_min"].replace(',', '.')) && parseFloat(valor) <= parseFloat(cultura[campo + "_n_max"].replace(',', '.'))) {
                    this.$set(this.analise.tecido, (campo + '_avaliacao'), 'Normal')
                }
                if (parseFloat(valor.replace(',', '.')) >= parseFloat(cultura[campo + "_a_min"].replace(',', '.'))) {
                    this.$set(this.analise.tecido, (campo + '_avaliacao'), 'Alto')
                }
            },

            calculaSMP() {
                if (this.analise.solo.ph == "") {
                    this.analise.solo.smp = "";
                    this.analise.solo.hidrogenio_al = "";
                }
                else {
                    // Calcula o SMP
                    let ph = parseFloat(this.analise.solo.ph.replace(',', '.'));
                    let smp = '';

                    if (ph <= 3.7) smp = 4;
                    else if (ph == 3.8) smp = 4.1;
                    else if (ph == 3.9) smp = 4.2;
                    else if (ph == 4) smp = 4.4;
                    else if (ph == 4.1) smp = 4.4;
                    else if (ph == 4.2) smp = 4.5;
                    else if (ph == 4.3) smp = 4.6;
                    else if (ph == 4.4) smp = 4.8;
                    else if (ph == 4.5) smp = 4.9;
                    else if (ph == 4.6) smp = 5;
                    else if (ph == 4.7) smp = 5.1;
                    else if (ph == 4.8) smp = 5.2;
                    else if (ph == 4.9) smp = 5.2;
                    else if (ph == 5) smp = 5.3;
                    else if (ph == 5.1) smp = 5.4;
                    else if (ph == 5.2) smp = 5.4;
                    else if (ph == 5.3) smp = 5.5;
                    else if (ph == 5.4) smp = 5.6;
                    else if (ph == 5.5) smp = 5.7;
                    else if (ph == 5.6) smp = 5.8;
                    else if (ph == 5.7) smp = 5.9;
                    else if (ph == 5.8) smp = 6;
                    else if (ph == 5.9) smp = 6.1;
                    else if (ph == 6) smp = 6.2;
                    else if (ph == 6.1) smp = 6.3;
                    else if (ph == 6.2) smp = 6.4;
                    else if (ph == 6.3) smp = 6.5;
                    else if (ph == 6.4) smp = 6.6;
                    else if (ph == 6.5) smp = 6.6;
                    else if (ph == 6.6) smp = 6.7;
                    else if (ph == 6.7) smp = 6.7;
                    else if (ph == 6.8) smp = 6.8;
                    else if (ph == 6.9) smp = 6.9;
                    else if (ph == 7) smp = 7;
                    else if (ph == 7.1) smp = 7.1;
                    else if (ph == 7.2) smp = 7.2;
                    else if (ph > 7.2) smp = ph;

                    this.$set(this.analise.solo, 'smp', smp);


                    // Calcula o Hidrogênio + Al (H + Al)
                    let hidrogenio_al = '';
                    if (smp <= 4)        hidrogenio_al = '21,7';
                    else if (smp == 4.1) hidrogenio_al = '19,8';
                    else if (smp == 4.2) hidrogenio_al = '18,1';
                    else if (smp == 4.3) hidrogenio_al = '16,5';
                    else if (smp == 4.4) hidrogenio_al = '15,1';
                    else if (smp == 4.5) hidrogenio_al = '13,8';
                    else if (smp == 4.6) hidrogenio_al = '12,6';
                    else if (smp == 4.7) hidrogenio_al = '11,5';
                    else if (smp == 4.8) hidrogenio_al = '10,5';
                    else if (smp == 4.9) hidrogenio_al = '9,6';
                    else if (smp == 5)   hidrogenio_al = '8,8';
                    else if (smp == 5.1) hidrogenio_al = '8';
                    else if (smp == 5.2) hidrogenio_al = '7,3';
                    else if (smp == 5.3) hidrogenio_al = '6,7';
                    else if (smp == 5.4) hidrogenio_al = '6,1';
                    else if (smp == 5.5) hidrogenio_al = '5,6';
                    else if (smp == 5.6) hidrogenio_al = '5,1';
                    else if (smp == 5.7) hidrogenio_al = '4,7';
                    else if (smp == 5.8) hidrogenio_al = '4,3';
                    else if (smp == 5.9) hidrogenio_al = '3,9';
                    else if (smp == 6)   hidrogenio_al = '3,6';
                    else if (smp == 6.1) hidrogenio_al = '3,3';
                    else if (smp == 6.2) hidrogenio_al = '3';
                    else if (smp == 6.3) hidrogenio_al = '2,7';
                    else if (smp == 6.4) hidrogenio_al = '2,5';
                    else if (smp == 6.5) hidrogenio_al = '2,3';
                    else if (smp == 6.6) hidrogenio_al = '2,1';
                    else if (smp == 6.7) hidrogenio_al = '1,9';
                    else if (smp == 6.8) hidrogenio_al = '1,7';
                    else if (smp == 6.9) hidrogenio_al = '1,6';
                    else if (smp == 7)   hidrogenio_al = '1,4';
                    else if (smp == 7.1) hidrogenio_al = '1,3';
                    else if (smp == 7.2) hidrogenio_al = '1,2';
                    else if (smp == 7.3) hidrogenio_al = '1,1';
                    else if (smp == 7.4) hidrogenio_al = '1';
                    else if (smp == 7.5) hidrogenio_al = '0,9';
                    else if (smp == 7.6) hidrogenio_al = '0,8';
                    else if (smp == 7.7) hidrogenio_al = '0,8';
                    else if (smp == 7.8) hidrogenio_al = '0,7';
                    else if (smp == 7.9) hidrogenio_al = '0,7';
                    else if (smp == 8)   hidrogenio_al = '0,6';
                    else if (smp == 8.1) hidrogenio_al = '0,5';
                    else if (smp == 8.2) hidrogenio_al = '0,5';
                    else if (smp == 8.3) hidrogenio_al = '0,4';
                    else if (smp == 8.4) hidrogenio_al = '0,4';
                    else if (smp == 8.5) hidrogenio_al = '0,4';
                    else if (smp == 8.6) hidrogenio_al = '0,3';
                    else if (smp == 8.7) hidrogenio_al = '0,3';
                    else if (smp == 8.8) hidrogenio_al = '0,3';
                    else if (smp == 8.9) hidrogenio_al = '0,3';
                    else if (smp == 9)   hidrogenio_al = '0,2';
                    else if (smp == 9.1) hidrogenio_al = '0,2';
                    else if (smp == 9.2) hidrogenio_al = '0,2';
                    else if (smp == 9.3) hidrogenio_al = '0,2';
                    else if (smp == 9.4) hidrogenio_al = '0,2';
                    else if (smp == 9.5) hidrogenio_al = '0,2';
                    else if (smp == 9.6) hidrogenio_al = '0,1';
                    else if (smp == 9.7) hidrogenio_al = '0,1';
                    else if (smp == 9.8) hidrogenio_al = '0,1';
                    else if (smp == 9.9) hidrogenio_al = '0,1';
                    else if (smp >= 10)  hidrogenio_al = '0,1';

                    this.$set(this.analise.solo, 'hidrogenio_al', hidrogenio_al);
                }
            },

            calculaSilte() {
                if (this.analise.solo_fisica == 1) {
                    let valor1 = (this.analise.solo.argila == "" ? 0 : parseInt(this.analise.solo.argila));
                    let valor2 = (this.analise.solo.areia == "" ? 0 : parseInt(this.analise.solo.areia));
                    this.$set(this.analise.solo, 'silte', parseInt(100 - (valor1 + valor2)));
                }
            },

            async validaDestinatarioBoleto() {
                if (this.analise.forma_pagamento != "BOLETO" || (this.analise.forma_pagamento == "BOLETO" && this.analise.pedido_id != null)) {
                    return true
                }

                let destino = this.analise.boleto.value
                let pessoa = null

                if (destino == 'REMETENTE' && this.analise.remetente != null) {
                    pessoa = this.analise.remetente
                } else if (destino == 'PROPRIETARIO' && this.analise.proprietarios[0] != null) {
                    pessoa = this.analise.proprietarios[0]
                } else if (destino == 'ARRENDATARIO' && this.analise.arrendatarios[0] != null) {
                    pessoa = this.analise.arrendatarios[0]
                }


                pessoa = this.validaCpfCnpj(pessoa)
                if (!pessoa) {
                    window.swal("Atenção", "Informe o CPF / CNPJ do destinatário do boleto antes de continuar.", "warning");
                    return false;
                }

                let data = null
                if (pessoa.endereco == null || pessoa.endereco == '' || pessoa.bairro == null || pessoa.bairro == '' || pessoa.cep == null || pessoa.cep == '' || pessoa.cidade_id == null) {
                    if (destino == 'REMETENTE' || ((destino == 'PROPRIETARIO' || destino == 'ARRENDATARIO') && (this.analise.remetente.endereco == null || this.analise.remetente.endereco == '' || this.analise.remetente.bairro == null || this.analise.remetente.bairro == '' || this.analise.remetente.cep == null || this.analise.remetente.cep == '' || this.analise.remetente.cidade_id == null))) {
                        //pega empresa
                        data = {'pessoaAtualizar': pessoa.id, 'pessoaDados': {'empresa': true}}
                    } else {
                        if (this.analise.remetente.endereco == null || this.analise.remetente.endereco == '' || this.analise.remetente.bairro == null || this.analise.remetente.bairro == '' || this.analise.remetente.cep == null || this.analise.remetente.cep == '' || this.analise.remetente.cidade_id == null) {
                            window.swal("Atenção", "Remetente e proprietário sem informações para geração de boleto.", "warning");
                            return false;
                        }

                        //pega remetente
                        data = {
                            'pessoaAtualizar': pessoa.id,
                            'pessoaDados': {'empresa': false, 'remetente': this.analise.remetente}
                        }
                    }

                    await this.$http.post("api/pessoas/atualiza-endereco-cadastro", data)
                }
                this.$set(this.analise, 'pessoa_id', pessoa.id)
                return true
            },

            validaCpfCnpj(pessoa) {
                let tipo = pessoa.tipo
                let pessoaCorreta = false

                if ((tipo == 2 && pessoa.cnpj != null && pessoa.cnpj != '') || (tipo == 1 && pessoa.cpf != null && pessoa.cpf != '')) {
                    return pessoa
                }

                if (this.analise.boleto.value == 'REMETENTE') {
                    return false
                }

                if (this.analise.proprietarios.length > 0 && !pessoaCorreta) {
                    this.analise.proprietarios.forEach((proprietario) => {
                        if (!pessoaCorreta && ((tipo == 2 && proprietario.cnpj != null && proprietario.cnpj != '') || (tipo == 1 && proprietario.cpf != null && proprietario.cpf != ''))) {
                            pessoaCorreta = proprietario;
                        }
                    })
                }

                if (this.analise.arrendatarios.length > 0 && !pessoaCorreta) {
                    this.analise.arrendatarios.forEach((arrendatario) => {
                        if (!pessoaCorreta && ((tipo == 2 && arrendatario.cnpj != null && arrendatario.cnpj != '') || (tipo == 1 && arrendatario.cpf != null && arrendatario.cpf != ''))) {
                            pessoaCorreta = arrendatario;
                        }
                    })
                }

                return pessoaCorreta
            },

            async enviarResultado() {
                let analise = this.analise
                await this.validaDestinatarioBoleto().then((response) => {
                    if (!response) {
                        return false;
                    } else {
                        analise.boleto = analise.boleto != null ? analise.boleto.value : null;
                        window.swal({
                            title: "Armazenando resultado",
                            imageUrl: require("@/assets/logo.png"),
                            imageWidth: "100px",
                            animation: false,
                            allowOutsideClick: false,
                            onOpen: () => {
                                window.swal.showLoading();

                                this.$http.post('api/analises/resultado', analise).then(async (response) => {
                                    if (response.data.erro == '1') {
                                        window.swal("Atenção", "Erro ao digitar resultado. <BR>" + response.data.mensagem, "warning");
                                        return false
                                    }

                                    if (analise.pedido_id == null && analise.forma_pagamento == "BOLETO") {
                                        await armazenaPedido.enviar([Object.assign({}, analise)], true);
                                    }

                                    this.$http.get("api/analises/get-resultado/" + analise.id).then(async response => {
                                        if (analise.remetente.preco != null && analise.remetente.preco.imprime_resultado == '1') {
                                            if (response.data.pdf == null) {
                                                return window.swal(
                                                    "Atenção",
                                                    "Houve um problema ao gerar o resultado.<br><br>" +
                                                    response.data.mensagem,
                                                    "warning"
                                                );
                                            }
                                            let a = document.createElement("a");
                                            a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                            a.download = "Resultado " + analise.tipo + "/" + analise.registro + "/" + analise.ano_registro + ".pdf";
                                            a.click();
                                        }

                                        if (response.data.pdfBoleto != null) {
                                            let a = document.createElement("a");
                                            a.href = "data:application/octet-stream;base64," + response.data.pdfBoleto;
                                            a.download = "Boleto " + analise.tipo + "/" + analise.registro + "/" + analise.ano_registro + ".pdf";
                                            a.click();
                                        }

                                        if (response.data.pdfNfse != null) {
                                            let a = document.createElement("a");
                                            a.href = "data:application/octet-stream;base64," + response.data.pdfNfse;
                                            a.download = "NFSe " + analise.tipo + "/" + analise.registro + "/" + analise.ano_registro + ".pdf";
                                            a.click();
                                        }

                                        await this.$http.post("api/analises/mail/" + analise.id);
                                        window.swal("Atenção", "Resultado armazenado com sucesso", "success");
                                    });
                                    return this.$router.push({name: 'analises', params: {'GUIA': 'PENDENTES', 'TIPO': analise.tipo}});
                                }).catch(error => {
                                    return window.swal("Atenção", "Houve um problema ao armazenar o resultado. <br><br>" + error, "warning");
                                })
                            }
                        });
                    }
                })
            }
        },

        mounted() {
            let model = JSON.parse(JSON.stringify(this.$store.state.Form.toEdit));
            this.$store.dispatch('setConfiguracao');

            if (model !== null) {
                model.boleto = {
                    value: model.boleto,
                    label: model.boleto === "REMETENTE" ? "Remetente" : (model.boleto === "ARRENDATARIO" ? "Proprietário / Cedente" : "Produtor / Proprietário")
                };
                this.$set(this, 'analise', model);

                if (model.tipo === 'SOLO') {
                    this.calculaSMP();
                    this.calculaSilte();

                    this.analise.solo.ph_cacl2 = '';
                    this.analise.solo.fosforo_resina = '';
                    this.analise.solo.ferro = '';
                    this.analise.solo.silicio = '';
                    this.analise.solo.condutividade = '';
                    this.analise.solo.nitrogenio_azoto = '';
                }

                let data = new Date()
                let dias = this.analise.remetente.preco != null && this.analise.remetente.preco.dias_vencimento_boleto > 0 ? this.analise.remetente.preco.dias_vencimento_boleto : 30
                data.setDate(data.getDate() + parseInt(dias));
                this.$set(this.analise, "data_vencimento", data.toISOString().substr(0, 10));
            } else {
                this.$router.push({name: 'analises'});
            }
            this.$store.dispatch('setTitle', 'Resultado da análise - ' + this.analise.tipo + " - " + this.analise.registro + ' / ' + this.analise.ano_registro)
        },

        filters: {
            formataData: function (value) {
                if (!value) {
                    return '';
                }
                return value.substring(8, 10) + '/' + value.substring(5, 7) + '/' + value.substring(0, 4);
            }
        }
    }
</script>
